"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSwitchButtons = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var __1 = require("..");
var InputSwitchButtons = function (_a) {
    var className = _a.className, options = _a.options, onChange = _a.onChange, value = _a.value;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className) },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('br-w-full'), style: { display: 'inline-flex', alignItems: 'center' } }, options.map(function (option, i) { return (react_1.default.createElement(__1.Button, { key: option.name, buttonType: option.value == value ? 'primary' : 'primary-outline', size: "sm", onClick: function () { return onChange(option.value); }, className: (0, classnames_1.default)('br-w-full'), style: {
                /***
                  Button has already an br-rounden defined and due no overwriting in classNames.
                  That's why borders are added in style
                 ***/
                borderTopLeftRadius: i == 0 ? ' md' : 0,
                borderBottomLeftRadius: i == 0 ? 'md' : 0,
                borderTopRightRadius: options.length - 1 == i ? ' md' : 0,
                borderBottomRightRadius: options.length - 1 == i ? ' md' : 0
            } }, option.name)); }))));
};
exports.InputSwitchButtons = InputSwitchButtons;
